import React from 'react';
import PropTypes from 'prop-types';
import Pagination from '../../components/common/Pagination';
import Spinner from '../common/Spinner';

export default function WrapperColumnRetailers(props) {
  const { children, pageCount = 1 } = props;

  if (props.isLoadingProducts) {
    return <Spinner />;
  }

  return (
    <div className="column_products_retailers">
      <div className="row vertical-indent">{children}</div>

      <Pagination pageCount={pageCount} handlePageClick={props.handlePageClick} currentPage={props.currentPage} />
    </div>
  );
}

WrapperColumnRetailers.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array.isRequired, PropTypes.element.isRequired]),
  pageCount: PropTypes.number,
  handlePageClick: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  isLoadingProducts: PropTypes.bool,
};
